exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ndiv#sideBar .is-padding-top-0 {\n  padding-top: 0;\n}\n.share-link {\n  color: #58595b;\n  font-size: 12px;\n  width: 500px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\n", "", {"version":3,"sources":["/app/src/pages/collect-reviews/ReviewsShare.vue"],"names":[],"mappings":";AACA;EACE,eAAe;CAChB;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;CACzB","file":"ReviewsShare.vue","sourcesContent":["\ndiv#sideBar .is-padding-top-0 {\n  padding-top: 0;\n}\n.share-link {\n  color: #58595b;\n  font-size: 12px;\n  width: 500px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bdaa9c2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/collect-reviews/ReviewsShare.vue
// module id = Ns2+
// module chunks = 4